export const JOB_TYPES = [
  { value: 'crop_protection', label: 'Crop Protection' },
  { value: 'fertilisation', label: 'Fertilisation' },
  { value: 'dispatch', label: 'Dispatch' }
];
